import { useSearch } from '@tanstack/react-router';

import { UI_LANGUAGE_COOKIE } from './consts';
import type { Direction } from './locale.utils';
import { getDirectionFromLanguage } from './locale.utils';
import { getCookie } from '../client/utils/cookies';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../common/consts/supportedLanguages';
import type { SupportedLocale } from '../common/types/SupportedLocale';

export function useUiLanguage() {
  const search = useSearch({ strict: false });
  const langFromUrl = (search as Record<string, unknown>)?.lang as string | undefined;
  const langFromCookie = getCookie(UI_LANGUAGE_COOKIE) as SupportedLocale | undefined;

  // Prefer URL param (reactive via router), fallback to cookie, then default
  const uiLanguage: SupportedLocale =
    langFromUrl && (SUPPORTED_LANGUAGES as readonly string[]).includes(langFromUrl)
      ? (langFromUrl as SupportedLocale)
      : langFromCookie ?? DEFAULT_LANGUAGE;

  const uiDirection: Direction = getDirectionFromLanguage(uiLanguage);

  return { uiLanguage, uiDirection };
}
